import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import privateAxios from "../utils/axiosPrivate";
import { showToast } from "../utils/utils";
import { showToastType } from "../utils/constants/appConstants";
import { salesLeadText, commonErrMsg } from "../locales/en";

import {
  getArchiveSalesLeadURL,
  getDeleteSalesLeadURL,
  getRestoreSalesLeadURL,
  getSalesEditURL,
  getSalesLeadSearchURL,
  getSalesLeadsURL
} from "../utils/constants/apiEndPoints";

// Initial state
const initialState = {
  salesLeadloading: false,
  salesData: [],
  error: null
};

const salesLeadSlice = createSlice({
  name: "salesLeads",
  initialState,
  reducers: {
    setSalesLeads(state, action) {
      state.salesData = action.payload;
    },
    setSalesLeadLoading(state, action) {
      state.salesLeadloading = action.payload;
    },
    setSalesLeadError(state, action) {
      state.error = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // AddCase For getSalesLeadsThunk
      .addCase(getSalesLeadsThunk.pending, (state) => {
        state.salesLeadloading = true;
      })
      .addCase(getSalesLeadsThunk.fulfilled, (state) => {
        state.salesLeadloading = false;
      })
      .addCase(getSalesLeadsThunk.rejected, (state) => {
        state.salesLeadloading = false;
      })

      // AddCase For searchSalesLeadThunk
      .addCase(searchSalesLeadThunk.pending, (state) => {
        state.salesLeadloading = true;
      })
      .addCase(searchSalesLeadThunk.fulfilled, (state) => {
        state.salesLeadloading = false;
      })
      .addCase(searchSalesLeadThunk.rejected, (state) => {
        state.salesLeadloading = false;
      });
  }
});

// Thunk: Get Sales Leads
export const getSalesLeadsThunk = createAsyncThunk(
  "salesLeads/getSalesLeadsThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getSalesLeadsURL, {
        params: payload
      });

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        commonErrMsg.item7;

      showToast(message, showToastType.error);
    }
  }
);

// Thunk: search sales leads
export const searchSalesLeadThunk = createAsyncThunk(
  "salesLeads/searchSalesLeadThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getSalesLeadSearchURL, {
        params: payload
      });

      return response;
    } catch {
      // handle catch here;
    }
  }
);

// Thunk: edit sales lead
export const editSalesLeadThunk = createAsyncThunk(
  "salesLeads/editSalesLeadThunk",
  async (payload) => {
    try {
      const response = await privateAxios.get(getSalesEditURL(payload));

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        salesLeadText?.errMsg?.item8 ||
        commonErrMsg.item7;

      showToast(message);
    }
  }
);

// delete sales lead
export const deleteSalesLeadThunk = createAsyncThunk(
  "salesLeads/deleteSalesLeadThunk",
  async (payload) => {
    try {
      const response = await privateAxios.delete(
        getDeleteSalesLeadURL(payload)
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        salesLeadText?.errMsg?.item8 ||
        commonErrMsg.item7;

      showToast(message);
    }
  }
);
//achive sales lead

export const archiveSalesLeadThunk = createAsyncThunk(
  "salesLeads/archiveSalesLeadThunk",
  async (payload) => {
    try {
      const response = await privateAxios.patch(
        getArchiveSalesLeadURL(payload)
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        salesLeadText?.errMsg?.item8 ||
        commonErrMsg.item7;

      showToast(message);
    }
  }
);

export const restoreSalesLeadThunk = createAsyncThunk(
  "salesLeads/restoreSalesLeadThunk",
  async (payload) => {
    try {
      const response = await privateAxios.patch(
        getRestoreSalesLeadURL(payload)
      );

      return response;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.[0] ||
        error?.response?.data?.message ||
        error.message ||
        salesLeadText?.errMsg?.item8 ||
        commonErrMsg.item7;

      showToast(message);
    }
  }
);

// Actions & reducer
export const { setSalesLeads, setSalesLeadError } = salesLeadSlice.actions;

export default salesLeadSlice.reducer;
